import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import ProfileQuickview from "legacy/profile_quickview";

function useProfileQuickview() {
	const history = useHistory();
	useEffect(() => {
		ProfileQuickview.init({
			openPage: history.push,
		});
	}, [history]);
}

export default useProfileQuickview;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useProfileQuickview.js